import { Instagram } from 'lucide-react';
import { useEffect } from 'react';

export default function InstagramFeed() {
  useEffect(() => {
    // Cargar el script de Elfsight
    const script = document.createElement('script');
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    document.body.appendChild(script);

    // Esperar a que el widget se cargue y ocultar solo el branding
    const hideBranding = () => {
      setTimeout(() => {
        const widget = document.querySelector('.elfsight-app-4dabcfe2-1c28-4919-9c8b-4a76b57201b4');
        if (widget) {
          // Buscar y ocultar solo los enlaces de branding en el footer
          const links = widget.querySelectorAll('a');
          links.forEach(link => {
            const href = link.getAttribute('href') || '';
            const text = link.textContent.toLowerCase();
            if (href.includes('elfsight') || text.includes('free') || text.includes('widget') || text.includes('elfsight')) {
              link.style.display = 'none';
              // También ocultar el contenedor padre si solo contiene este enlace
              const parent = link.parentElement;
              if (parent && parent.children.length === 1) {
                parent.style.display = 'none';
              }
            }
          });
        }
      }, 2000); // Esperar 2 segundos a que el widget cargue
    };

    script.addEventListener('load', hideBranding);
    hideBranding(); // También ejecutar inmediatamente por si ya está cargado

    return () => {
      // Limpiar
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="space-y-6">
      {/* Elfsight Instagram Feed */}
      <div className="flex justify-center items-center">
        <div className="w-full">
          <div 
            className="elfsight-app-4dabcfe2-1c28-4919-9c8b-4a76b57201b4" 
            data-elfsight-app-lazy
          />
        </div>
      </div>

      {/* Botón Seguir en Instagram */}
      <div className="text-center mt-8">
        <a
          href="https://www.instagram.com/viajesdeensueno/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white px-8 py-3 rounded-full font-semibold hover:from-pink-600 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
        >
          <Instagram className="w-5 h-5" />
          Síguenos en Instagram
        </a>
      </div>
    </div>
  );
}
